<template>

  <NavBar v-if="showNavBar"></NavBar>

  <div style="margin-top: 60px;">
    <router-view />
  </div>
  <FooterBar v-if="showNavBar"/>
  <LoginRegisterModal v-model:visible="authStore.showLoginModal"/>

</template>

<script setup>
import NavBar from "@/components/NavBar.vue";
import FooterBar from "@/components/FooterBar.vue";
import LoginRegisterModal from "@/components/LoginRegisterModal.vue";
import {useAuthStore} from "@/stores/authStore";
import {useRoute} from "vue-router";
import {ref, watch} from "vue";
const authStore = useAuthStore();
const route = useRoute();

const showNavBar = ref(true)

// 监听路由变化以更新routeName
watch(() => route.name, (newName) => {
  console.log("当前路由名："+newName);
  if (newName === 'SignPage') {
    showNavBar.value = false;
  }else{
    showNavBar.value = true;
  }
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0 0 0 0;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Microsoft YaHei', sans-serif;

}
.view{
  margin-top: 70px;
}
</style>
